import React, { useRef } from 'react';
import { Button, Space } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export default function Uploader({ hasFile, previewUrl, onChange, onRemove, uploadTitle, uploadSub, removeLabel, replaceLabel }) {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (!hasFile) fileInputRef.current?.click();
  };

  const handleReplace = (e) => {
    e.stopPropagation();
    fileInputRef.current?.click();
  };

  return (
    <div className={`upload-area ${hasFile ? 'has-file' : ''}`} onClick={handleClick}>
      {!hasFile && (
        <>
          <div className="upload-icon"><UploadOutlined /></div>
          <div className="upload-title">{uploadTitle}</div>
          <div className="upload-subtitle">{uploadSub}</div>
        </>
      )}

      {hasFile && (
        <div className="upload-preview-container">
          <img src={previewUrl} alt="preview" className="upload-preview-image" />
          <div className="upload-actions-overlay">
            <Space className="upload-actions">
              <Button danger ghost onClick={(e) => { e.stopPropagation(); onRemove(); }}>{removeLabel}</Button>
              <Button type="primary" onClick={handleReplace}>{replaceLabel}</Button>
            </Space>
          </div>
        </div>
      )}

      <input ref={fileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={onChange} />
    </div>
  );
}


